export default __webpack_public_path__ + "static/media/DART.90a637a6.png";